<template>
  <div>
    <v-row
      dense
      justify=end>
      <v-col
        id="videoContainer"
        class="wrapper"
        cols=auto>
          <video id="remoteVideoDefault"></video>
      </v-col>
    </v-row>
    <v-row
      justify=end
      class="pb-0">
      <v-col
        class="pt-1 pb-0"
        cols=7>
        <v-container
          fluid>
          <v-row justify=end>
            <v-tooltip
              bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  @click="startVideo"
                  :disabled="isReadyToConnect"
                  fab
                  outlined
                  x-small
                  class="mr-1"
                >
                  <v-icon v-on="on">videocam</v-icon>
                </v-btn>
              </template>
              <span>start video</span>
            </v-tooltip>
            <v-tooltip
              bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  @click="stopVideo"
                  :disabled="!isReadyToConnect||inConnecting"
                  fab
                  outlined
                  x-small
                  class="mr-1"
                >
                  <v-icon v-on="on">videocam_off</v-icon>
                </v-btn>
              </template>
              <span>stop video</span>
            </v-tooltip>
            <v-tooltip
              bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  @click="connect"
                  :disabled="!isReadyToConnect||inConnecting"
                  fab
                  outlined
                  x-small
                  class="mr-1"
                >
                  <v-icon v-on="on">cast_connected</v-icon>
                </v-btn>
              </template>
              <span>connect</span>
            </v-tooltip>
            <v-tooltip
              bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  @click="hangUp"
                  :disabled="!inConnecting"
                  outlined
                  fab
                  x-small
                >
                  <v-icon v-on="on">mdi-phone-hangup</v-icon>
                </v-btn>
              </template>
              <span>hang up</span>
            </v-tooltip>
          </v-row>
          <v-row
            justify=end>
            <v-col
              class="main--text"
              cols=auto>
              <span>相手の状況</span><br>
              <span
                v-if="partnerExists"
                style="color:blue">
                オンライン
              </span>
              <span
                v-else
                style="color:grey">
                オフライン
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col
        cols=5
        class="pr-2 pl-0 pt-0">
        <div
          style="padding:0"
          >
        <div
        class="wrapper">
          <video id="localVideo" autoplay></video>
        </div>
          </div>
      </v-col>
    </v-row>
    <!-- <v-row
      v-if="$store.getters.isTeacher"
      class="no--vertical--paddings"
      justify=end>
      <v-col
        cols=auto
        class="no--vertical--paddings">
        <v-btn
          @click="createSsTimer()"
          fab
          x-small
          outlined
          :disabled="isTimerRunning"
        >
          <v-icon>
            mdi-camera
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols=auto
        class="no--vertical--paddings">
        <v-btn
          @click="clearSsTimer()"
          fab
          x-small
          outlined
          :disabled="!isTimerRunning"
          >
          <v-icon>
            mdi-camera-off
          </v-icon>
        </v-btn>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { app } from '@/core/firebase'
import adapter from 'webrtc-adapter'
import { SsSaver } from '@/service/lesson-ss/save'

export default {
  components: {
  },
  props: {
    room: {
      type: String,
      required: true
    },
    partnerId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      key: "",
      clientId: "",
      peerConnections: [],
      remoteVideos: [],
      localVideoContainer: null,
      localVideo: null,
      dataDebugFlag: true,
      db: null,
      dbRoot: 'chat/',
      roomBroadCastRef: {},
      clientRef: {},
      joinRef: {},
      localStream: null,
      inConnecting: false,
      partnerExists: false,
      ssTimer: null
    }
  },
  methods: {
    async connect () {
      if (!this.isReadyToConnect) {
      } else if (!this.canConnectMore) {
      } else {
        this.callMe()
      }
    },
    hangUp() {
      this.emitRoom({type: 'bye'})
      this.clearMessage()
      this.stopAllConnection()
    },
    addConnection(id, peer) {
      this.peerConnections[id] = peer
    },
    getConnection(id) {
      let peer = this.peerConnections[id]
      return peer
    },
    deleteConnection(id) {
      delete this.peerConnections[id]
    },
    isConnectedWith(id) {
      return (this.peerConnections[id]) ? true : false
    },
    stopConnection(id) {
      this.detachVideo(id)
      if (this.isConnectedWith(id)) {
        let peer = this.getConnection(id)
        peer.close()
        this.deleteConnection(id)
        this.inConnecting = false
      }
    },
    stopAllConnection() {
      for (let id in this.peerConnections) {
        this.stopConnection(id)
      }
    },
    callMe() {
      this.emitRoom({type: 'call me'})
    },
    emitRoom(msg) {
      msg.from = this.clientId
      this.roomBroadCastRef.push(msg)
    },
    emitTo(id, msg) {
      msg.from = this.clientId
      this.db.ref(this.dbRoot + this.room + '/_direct_/' + id).push(msg)
    },
    clearMessage() {
      this.clientRef.set({})
    },
    async makeOffer(id) {
      let peerConnection = this.prepareNewConnection(id)
      this.addConnection(id, peerConnection)

      try {
        const sessionDescription = await peerConnection.createOffer()
        await peerConnection.setLocalDescription(sessionDescription)
        this.sendSdp(id, peerConnection.localDescription)
      } catch (err) {
      }
    },
    async setOffer(id, sessionDescription) {
      let peerConnection = this.prepareNewConnection(id)
      this.addConnection(id, peerConnection)

      try {
        await peerConnection.setRemoteDescription(sessionDescription)
        await this.makeAnswer(id)
      } catch(err) {
      }
    },
    async makeAnswer(id) {
      let peerConnection = this.getConnection(id)
      if (!(peerConnection)) {
        return
      }

      try {
        const sessionDescription = await peerConnection.createAnswer()
        await peerConnection.setLocalDescription(sessionDescription)
        await this.sendSdp(id, peerConnection.localDescription)
      } catch(err) {
      }
    },
    async setAnswer(id, sessionDescription) {
      let peerConnection = this.getConnection(id)
      if (!peerConnection) {
        return
      }

      try {
        await peerConnection.setRemoteDescription(sessionDescription)
      } catch(err) {
      }
    },
    addIceCandidate(id, candidate) {
      let peerConnection = this.getConnection(id)
      if (peerConnection) {
        peerConnection.addIceCandidate(candidate)
      } else {
        return
      }
    },
    prepareNewConnection(id) {
      let self = this
      let pc_config = {"iceServers": [{"urls": "stun:stun.l.google.com:19302"}]}
      let peer = new RTCPeerConnection(pc_config)

      if ('ontrack' in peer) {
        peer.ontrack = function(event) {
          let stream = event.streams[0]
          if (self.isRemoteVideoAttached(id)) {
          } else {
            self.attachVideo(id, stream)
          }
        }
      } else {
        peer.onaddstream = function(event) {
          let stream = event.stream
          self.attachVideo(id, stream)
        }
      }

      peer.onicecandidate = function(evt) {
        if (evt.candidate) {
          self.sendIceCandidate(id, evt.candidate)
        } else {
        }
      }

      peer.onnegotiationneeded = function(evt) {
      }

      peer.onicecandidateerror = function(evt) {
      }

      peer.onsignalingstatechange = function() {
      }

      peer.oniceconnectionstatechange = function() {
        if (peer.iceConnectionState === 'closed') {
          self.stopConnection(id)
          self.clearMessage()
        } else if (peer.iceConnectionState === 'connected') {
          self.inConnecting = true
        }
      }

      peer.onicegatheringstatechange = function() {
      }

      peer.onconnectionstatechange = function() {
        if (peer.connectionState === 'connected') {
          self.inConnecting = true
        }
      }
      peer.onremovestream = function(event) {
        self.deleteRemoteStream(id)
        self.detachVideo(id)
      }

      // -- add local stream --
      if (self.localStream) {
        self.localStream.getTracks().forEach(function(track) {
          peer.addTrack(track, self.localStream)
        })
      }
      else {
      }

      return peer
    },
    sendSdp(id, sessionDescription) {
      let message = { type: sessionDescription.type, sdp: sessionDescription.sdp}
      this.emitTo(id, message)
    },
    sendIceCandidate(id, candidate) {
      let obj = { type: 'candidate', ice: JSON.stringify(candidate) }
      this.emitTo(id, obj)
    },
    attachVideo(id, stream) {
      let video = this.addRemoteVideoElement(id)
      this.playVideo(video, stream)
      video.volume = 1.0
    },
    addRemoteVideoElement(id) {
      let video = this.createVideoElement(id)
      this.remoteVideos[id] = video
      return video
    },
    createVideoElement(elementId) {
      let video = document.createElement('video')
      video.id = "remoteVideo"
      video.style.width = '100%'
      video.style.height = "100%"
      video.style.position = "relative"
      video.style.top = "0"
      let defaultVideo = document.getElementById('remoteVideoDefault')
      if (defaultVideo) {
        this.localVideoContainer.replaceChild(video, defaultVideo)
      }
      return video
    },
    detachVideo(id) {
      let video = this.getRemoteVideoElement(id)
      this.pauseVideo(video)
      this.deleteRemoteVideoElement(id)
    },
    isRemoteVideoAttached(id) {
      return (this.remoteVideos.length > 0) ? true : false
    },
    getRemoteVideoElement(id) {
      let video = this.remoteVideos[id]
      return video
    },
    deleteRemoteVideoElement(id) {
      this.removeVideoElement(id)
    },
    removeVideoElement(elementId) {
      let video = document.getElementById("remoteVideo")
      if (video) {
        let defaultVideo = document.createElement('video')
        defaultVideo.id = 'remoteVideoDefault'
        defaultVideo.style.backgroundColor = "rgb(95, 95, 95)"
        defaultVideo.style.width = '100%'
        defaultVideo.style.height = "100%"
        defaultVideo.style.position = "relative"
        defaultVideo.style.top = "0"
        this.localVideoContainer.replaceChild(defaultVideo, video)
        return video
      }
    },

    async startVideo() {
      try {
        const stream = await this.getDeviceStream({video: true, audio: true})
        this.localStream = stream
        await this.playVideo(this.localVideo, stream)
      } catch (err) {
        return
      }
    },
    getDeviceStream(option) {
      if ('getUserMedia' in navigator.mediaDevices) {
        return navigator.mediaDevices.getUserMedia(option)
      } else {
        return new Promise(function(resolve, reject) {
          navigator.getUserMedia(option, resolve, reject)
        })
      }
    },
    playVideo(element, stream) {
      if ('srcObject' in element) {
        element.srcObject = stream
      } else {
        element.stc = window.URL.createObjectURL(stream)
      }
      element.play()
      element.volume = 0
    },
    stopVideo() {
      this.pauseVideo(this.localVideo)
      this.stopLocalStream(this.localStream)
      this.localStream = null
    },
    stopLocalStream(stream) {
      let tracks = stream.getTracks()
      if (! tracks) {
        return
      }
      for (let track of tracks) {
        track.stop()
      }
    },
    pauseVideo(element) {
      element.pause()
      if ('srcObject' in element) {
        element.srcObject = null
      } else {
        if (element.src && (element.src !== '')) {
          window.URL.revokeObjectURL(element.src)
        }
        element.src = ''
      }
    },

    async capture(){
      const video = document.getElementById('remoteVideo')
      const canvas = document.createElement('canvas')
      canvas.width = 400
      canvas.height = 300
      const context = canvas.getContext('2d')
      context.drawImage(video, 0, 0, 400, 300)
      context.canvas.toBlob(async blob => {
        const ssSaver = new SsSaver()
        const result = await ssSaver.execute(this.room, blob)
      })
    },

    createSsTimer() {
      this.ssTimer = setInterval(this.capture, 30000)
    },
    clearSsTimer() {
      clearInterval(this.ssTimer)
      this.ssTimer = null
    }
  },
  mounted: function() {
    this.localVideoContainer = document.getElementById('videoContainer')
    this.localVideo = document.getElementById('localVideo')
    this.db = app.database()

    const user = (this.$store.getters.parent) ? this.$store.getters.parent : this.$store.getters.teacher
    this.key = user.getId()
    this.clientId = 'member_' + this.key
    this.db.ref(this.dbRoot + this.room + '/_join_/' + this.key).update({ joined: this.clientId})
    let self = this


    this.roomBroadCastRef = this.db.ref(this.dbRoot + this.room + '/_broad_')
    this.roomBroadCastRef.on('child_added', function(data) {
      let message = data.val()
      let fromId = message.from
      if (fromId === self.clientId) {
        return
      }
      if (message.type === 'call me') {
        if (!self.isReadyToConnect) {
          return
        } else if (!self.canConnectMore) {
        }
        if (self.isConnectedWith(fromId)) {
        } else {
          self.makeOffer(fromId)
        }
      } else if (message.type === 'bye'){
        if (self.isConnectedWith(fromId)) {
          self.stopConnection(fromId)
        }
      }
    })

    this.clientRef = this.db.ref(this.dbRoot + this.room + '/_direct_/' + this.clientId)
    this.clientRef.on('child_added', function(data) {
      let message = data.val()
      let fromId = message.from

      if (message.type === 'offer' ) {
        let offer = new RTCSessionDescription(message)
        self.setOffer(fromId, offer)
      } else if (message.type === 'answer') {
        let answer = new RTCSessionDescription(message)
        self.setAnswer(fromId, answer)
      } else if (message.type === 'candidate') {
        let candidate = new RTCIceCandidate(JSON.parse(message.ice))
        self.addIceCandidate(fromId, candidate)
      }
    })

    this.joinRef = this.db.ref(this.dbRoot + this.room + '/_join_')
    this.joinRef.on('child_added', function(data) {
      let message = data.val()
      let fromId = message.joined
      if (fromId === 'member_' + self.partnerId) {
        self.partnerExists = true
      }
    })
    this.joinRef.on('child_removed', function(data) {
      let message = data.val()
      let fromId = message.joined
      if (fromId === 'member_' + self.partnerId) {
        self.partnerExists = false
      }
    })

    window.addEventListener('beforeunload', function(event){
      let joinRef = self.db.ref(self.dbRoot + self.room + '/_join_/' + self.key)
      event.returnValue = joinRef.remove()
    })

  },
  beforeDestroy: function() {

    let self = this

    let joinRef = self.db.ref(self.dbRoot + self.room + '/_join_/' + self.key)
    joinRef.remove()

    if (this.localStream) {
      this.stopVideo()
    }

    if (!self.dataDebugFlag) {
      let messageRef = self.db.ref(self.dbRoot + self.room + '/_direct_/' + self.clientId + '/' + data.key)
      self.inConnecting = false
    }

  },
  computed: {
    isReadyToConnect() {
      return this.localStream ? true : false
    },
    getConnectionCount() {
      return this.peerConnections.length
    },
    canConnectMore() {
      return (this.getConnectionCount < 1)
    },
    isTimerRunning() {
      return (this.ssTimer) ? true : false
    }
  }
}
</script>

<style scoped>
.wrapper {
  height: 100%;
  width: 100%;
  position: relative;
  padding: 0;
}

#localVideo {
  width: 100%;
  height: 100%;
  background-color: white;
  box-shadow: inset 0 0 2px 12px rgb(95, 95, 95);
  position: relative;
  top: 0
}

#remoteVideoDefault {
  background-color: white;
  box-shadow:  inset 0 0 2px 20px rgb(95, 95, 95);
  height: 100%;
  width: 100%;
  position: relative;
  top: 0;
}

.no--vertical--paddings {
  padding: 0px 12px;
}
</style>
